import React, { useState } from 'react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Mail, Phone, MapPin } from 'lucide-react';
import { toast } from 'sonner';

export const Footer = () => {
  const [email, setEmail] = useState('');

  const handleNewsletterSubmit = (e) => {
    e.preventDefault();
    if (email) {
      toast.success('Successfully subscribed to industry insights!');
      setEmail('');
    }
  };

  return (
    <footer id="contact" className="bg-primary text-primary-foreground">
      {/* Newsletter Section */}
      <div className="border-b border-primary-foreground/20">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-3xl sm:text-4xl font-serif font-bold mb-4">
              Get Industry Insights
            </h2>
            <p className="text-primary-foreground/80 mb-8 text-lg">
              Stay updated with the latest in precision fabrication, industry trends, and engineering innovations.
            </p>
            <form onSubmit={handleNewsletterSubmit} className="flex flex-col sm:flex-row gap-4 max-w-2xl mx-auto">
              <Input
                type="email"
                placeholder="Enter your email address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="flex-1 bg-primary-foreground/10 border-primary-foreground/30 text-primary-foreground placeholder:text-primary-foreground/60 focus:border-accent h-12"
              />
              <Button
                type="submit"
                className="bg-accent hover:bg-accent-hover text-accent-foreground font-semibold px-8 h-12"
              >
                Subscribe
              </Button>
            </form>
          </div>
        </div>
      </div>

      {/* Main Footer Content */}
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company Info */}
          <div>
            <div className="flex items-center space-x-2 mb-6">
              <div className="w-10 h-10 bg-primary-foreground rounded-md flex items-center justify-center">
                <span className="text-primary font-serif font-bold text-xl">W</span>
              </div>
              <div className="flex flex-col">
                <span className="font-serif font-bold text-lg leading-none">WeldPoint</span>
                <span className="text-xs tracking-wider text-primary-foreground/80">INDUSTRIES</span>
              </div>
            </div>
            <p className="text-primary-foreground/80 leading-relaxed mb-6">
              Delivering precision engineering and high-tolerance welding solutions for complex industrial challenges across South Africa. Your partner in quality fabrication.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-serif font-bold text-lg mb-6">Quick Links</h3>
            <ul className="space-y-3">
              <li>
                <a href="#process" className="text-primary-foreground/80 hover:text-accent transition-colors">
                  Our Process
                </a>
              </li>
              <li>
                <a href="#industries" className="text-primary-foreground/80 hover:text-accent transition-colors">
                  Industries
                </a>
              </li>
              <li>
                <a href="#faq" className="text-primary-foreground/80 hover:text-accent transition-colors">
                  FAQ
                </a>
              </li>
              <li>
                <a href="#" className="text-primary-foreground/80 hover:text-accent transition-colors">
                  Certifications
                </a>
              </li>
              <li>
                <a href="#" className="text-primary-foreground/80 hover:text-accent transition-colors">
                  Case Studies
                </a>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="font-serif font-bold text-lg mb-6">Services</h3>
            <ul className="space-y-3">
              <li className="text-primary-foreground/80">Structural Welding</li>
              <li className="text-primary-foreground/80">Custom Fabrication</li>
              <li className="text-primary-foreground/80">Material Sourcing</li>
              <li className="text-primary-foreground/80">Quality Inspection</li>
              <li className="text-primary-foreground/80">On-site Services</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="font-serif font-bold text-lg mb-6">Contact Us</h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <MapPin className="w-5 h-5 flex-shrink-0 mt-0.5 text-accent" />
                <span className="text-primary-foreground/80">
                  Midrand, Gauteng<br />
                  South Africa
                </span>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="w-5 h-5 flex-shrink-0 text-accent" />
                <a href="tel:+27872659845" className="text-primary-foreground/80 hover:text-accent transition-colors">
                  +27 87 265 9845
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="w-5 h-5 flex-shrink-0 text-accent" />
                <a href="mailto:info@weldpointindustries.co.za" className="text-primary-foreground/80 hover:text-accent transition-colors break-all">
                  info@weldpointindustries.co.za
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-primary-foreground/20">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-4 text-sm text-primary-foreground/70">
            <p>© 2026 WeldPoint Industries. All rights reserved.</p>
            <div className="flex gap-6">
              <a href="#" className="hover:text-accent transition-colors">Privacy Policy</a>
              <a href="#" className="hover:text-accent transition-colors">Terms of Service</a>
              <a href="#" className="hover:text-accent transition-colors">Cookie Policy</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
